// 采用静态导入，获得更好的类型支持和Tree Shaking
import CommonAPI from '@/components/common/api';
import BusinessAPI from '../components/business/api';
import HomeAPI from './Home/api';
import LayoutAPI from './Layout/api';
import LoginApi from './Login/api';
import SearchAPI from './Search/api';
import UserCenterApi from './UserCenter/api';
// 定义模块API类型
type ModuleAPI = Record<string, { url: string; method?: string }>;

export const apiObj = {
  Search: SearchAPI,
  Home: HomeAPI,
  Common: CommonAPI,
  UserCenter: UserCenterApi,
  Login: LoginApi,
  Business: BusinessAPI,
  Layout: LayoutAPI,
} as const;

// 类型安全的 getApi 函数
export const getApi = (apiPath: string): string => {
  const [moduleName, apiKey] = apiPath.split('.');

  if (!moduleName || !apiKey) {
    console.error('API路径格式错误，应为 "模块名.API键名"');
    return '';
  }

  const module = apiObj[moduleName as keyof typeof apiObj] as ModuleAPI;
  if (!module) {
    console.error(`模块 "${moduleName}" 不存在`);
    return '';
  }

  const apiConfig = module[apiKey];
  if (!apiConfig) {
    console.error(`API "${apiKey}" 在模块 "${moduleName}" 中不存在`);
    return '';
  }

  return apiConfig.url;
};

// 导出模块类型
export type APIModules = keyof typeof apiObj;
export type APIKeys<T extends APIModules> = keyof (typeof apiObj)[T];
